import React from 'react';

// DEPENDENCIES
import clsx from 'clsx';

// STYLES
import styles from './activityItem.module.scss';
import { isArray } from 'lodash';

// MAIN COMPONENT
const ActivityItem = ({
  children,
  title,
  timeStamp
}) => (
  <div className={clsx(
    'border',
    styles.item
  )}>
    <div className={styles.header}>
      <h5 className={styles.title}>{title}</h5>
      {timeStamp && <div className={styles.dateTime}>{timeStamp}</div>}
    </div>
    {!!children && (!isArray(children) || !!children.filter(child => !!child).length) &&
      <div className={styles.body}>
        {children}
      </div>
    }
  </div>
);

// EXPORT
export default ActivityItem;
